module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-47.01916439.svg";